// extracted by mini-css-extract-plugin
export var measureBox = "_7t-0";